import { bus } from '../engine/EventBus';
import { save } from '../engine/SaveSystem';
import { shopGroups } from '../data/shop';

export class ShopPanel {
  readonly el: HTMLElement;
  onClose?: () => void;

  constructor(root: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'overlay hidden';
    root.appendChild(this.el);
    bus.on('coins:changed', () => { if (!this.el.classList.contains('hidden')) this.render(); });
  }

  show(): void {
    this.render();
    this.el.classList.remove('hidden');
  }
  hide(): void { this.el.classList.add('hidden'); }

  private render(): void {
    const groups = shopGroups();
    this.el.innerHTML = `
      <div class="panel">
        <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:10px">
          <h1 style="font-size:28px; margin:0">🛍️ Glimmerbloom Shop</h1>
          <div class="hud-chip">🪙 ${save.data.coins}</div>
        </div>
        <p class="subtitle">Find secret sparkles around the world to earn coins ✨</p>
        ${groups.map((g) => `
          <h2 style="margin-top:18px">${g.name}</h2>
          <div class="shop-grid">
            ${g.items.map((item) => {
              const owned = save.data.unlockedFurniture.includes(item.id);
              const canAfford = save.data.coins >= item.price;
              return `
                <div class="shop-card">
                  <div class="thumb">${item.emoji}</div>
                  <div class="name">${item.label}</div>
                  <div class="price">${owned ? 'Owned' : `🪙 ${item.price}`}</div>
                  ${owned
                    ? '<button class="btn secondary" disabled>In palette</button>'
                    : `<button class="btn" data-id="${item.id}" ${canAfford ? '' : 'disabled'}>Buy</button>`}
                </div>`;
            }).join('')}
          </div>
        `).join('')}
        <div class="menu-buttons" style="margin-top:20px">
          <button class="btn ghost" data-action="close">Leave shop</button>
        </div>
      </div>
    `;
    this.el.querySelectorAll('button[data-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = (btn as HTMLElement).dataset.id!;
        this.buy(id);
      });
    });
    this.el.querySelector('[data-action="close"]')?.addEventListener('click', () => this.onClose?.());
  }

  private buy(id: string): void {
    const groups = shopGroups();
    const item = groups.flatMap((g) => g.items).find((i) => i.id === id);
    if (!item) return;
    if (save.data.coins < item.price) return;
    if (save.data.unlockedFurniture.includes(id)) return;
    save.data.coins -= item.price;
    save.data.unlockedFurniture.push(id);
    bus.emit('coins:changed', { coins: save.data.coins });
    bus.emit('shop:purchase', { id });
    bus.emit('save:dirty', {});
    bus.emit('toast', { message: `✨ Purchased ${item.label}!` });
    this.render();
  }
}
